module.exports = __webpack_public_path__ + "static/media/character.d27bbfce.svg";